import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Button, Input } from "reactstrap";
import MyLoader from "./util/loader";
import Api from "./api/api";
import { ToastContainer } from "react-toastify";
import moment from "moment";

const Chat = () => {
  const location = useLocation();
  const model = location.state.model;
  const user = model.user
    ? model.user
    : { fname: "unknown", lname: "", id: model.user_id };

  const [models, setModels] = useState([]);
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);

  let intervalID = useRef(null);

  // load data
  useEffect(() => {
    loadData(true);
    schedular();
    Api.updateChatStatus("Online");

    return () => {
      clearInterval(intervalID.current);
      Api.updateChatStatus("Away");
    };
  }, []);

  const schedular = () => {
    intervalID.current = setInterval(() => {
      loadData(false);
    }, 5000);
  };

  const sendMessage = () => {
    if (message === "" || !user) {
      return;
    }
    setLoader(true);
    Api.sendMessage(
      "admin",
      user.id,
      message,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          let temp = models;
          temp = temp.concat(response.data);
          setModels(temp);
          setMessage("");
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const loadData = (loader) => {
    if (loader) setLoader(true);

    Api.getChat(
      user.id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          let models = response.data;
          // models = models.concat(models[0]);
          setModels(models);
          setTimeout(() => {
            var objDiv = document.getElementById("scrollView");
            if (objDiv != null) objDiv.scrollTop = objDiv.scrollHeight;
          }, 50);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const getMessageTime = (model) => {
    let today = moment().format("DD/MM/YYYY");
    let date = moment(model.user_time).format("DD/MM/YYYY");
    if (today === date) {
      return moment(model.user_time).format("h:mm a");
    }
    return moment(model.user_time).format("h:mm a, DD/MM/YYYY");
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          {user.fname + " " + user.lname}
          {/* ({user.chat_status}) */}
        </div>
      </div>
      <div style={{ marginTop: 30 }}></div>
      <div
        id="scrollView"
        style={{
          overflow: "scroll",
          padding: 15,
          height: "68vh",
          width: 600,
          backgroundColor: "#ffffff",
          alignSelf: "center",
          borderRadius: 10,
          border: "1px solid lightgray",
        }}
      >
        {models.map((model, index) => {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {model.sender === "user" ? (
                <div style={{ alignItems: "center", justifyContent: "center" }}>
                  <div
                    style={{
                      alignSelf: "flex-start",
                      padding: 5,
                      backgroundColor: "#A9F5D0",
                      color: "black",
                      borderRadius: 5,
                      marginBottom: 0,
                      width: "85%",
                    }}
                  >
                    <div>{model.message}</div>
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      color: "gray",
                      marginLeft: 5,
                      marginBottom: 10,
                    }}
                  >
                    {getMessageTime(model)}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignSelf: "flex-end",
                      padding: 5,
                      backgroundColor: "#A9E2F3",
                      color: "black",
                      borderRadius: 5,
                      marginBottom: 0,
                      width: "85%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "flex", alignSelf: "flex-end" }}>
                      {model.message}
                    </div>
                  </div>
                  <div
                    style={{
                      alignSelf: "flex-end",
                      fontSize: 14,
                      color: "gray",
                      marginRight: 5,
                      marginBottom: 10,
                    }}
                  >
                    {getMessageTime(model)}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <Form
        className="form"
        style={{
          padding: 0,
          flex: 1,
          width: 600,
          alignSelf: "center",
          marginTop: 10,
          backgroundColor: "white",
        }}
      >
        <FormGroup
          style={{ marginBottom: 0, display: "flex", alignItems: "center" }}
        >
          <Input
            type="text"
            placeholder="Enter message..."
            value={message}
            onChange={(event) => {
              setMessage(event.target.value);
            }}
          />
          <Button
            style={{ marginLeft: 10, fontSize: 16 }}
            className="btn-block btn-dark"
            onClick={sendMessage}
          >
            Send
          </Button>
        </FormGroup>
      </Form>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default Chat;
